/** Explicit sidebar navigation discards a section's open item and local filters after the guard permits it. */
export const sectionRootNavigation = { sectionRoot: true } as const;

export function isSectionRootNavigation(state: unknown): boolean {
  return typeof state === 'object' && state !== null &&
    (state as Partial<typeof sectionRootNavigation>).sectionRoot === true;
}
